var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFileAddLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19657)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7 11.2C14.3075 11.2 13.2 12.3075 13.2 13.7V34.5C13.2 35.8925 14.3075 37 15.7 37H32.5C33.8925 37 35 35.8925 35 34.5V18.5556L27.6444 11.2H15.7ZM11 13.7C11 11.0925 13.0925 9 15.7 9H28.1C28.3917 9 28.6715 9.11589 28.8778 9.32218L36.8778 17.3222C37.0841 17.5285 37.2 17.8083 37.2 18.1V34.5C37.2 37.1075 35.1075 39.2 32.5 39.2H15.7C13.0925 39.2 11 37.1075 11 34.5V13.7Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.679 9.08373C28.0901 8.91348 28.5632 9.00759 28.8778 9.32218L36.8778 17.3222C37.1924 17.6368 37.2865 18.1099 37.1163 18.521C36.946 18.932 36.5449 19.2 36.1 19.2H29.3C27.9925 19.2 27 18.2075 27 16.9V10.1C27 9.65509 27.268 9.25399 27.679 9.08373ZM29.2 12.7556V16.9C29.2 16.9433 29.2075 16.9671 29.2111 16.9762C29.2131 16.981 29.2146 16.9836 29.2153 16.9847C29.2164 16.9854 29.219 16.9869 29.2238 16.9889C29.2329 16.9925 29.2567 17 29.3 17H33.4444L29.2 12.7556Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1001 26H30.1001V28.2H18.1001V26Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2001 21.0996V33.0996H23.0001V21.0996H25.2001Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.2,
    height: 30.2,
    fill: "white",
    transform: "translate(11 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileAddLight);
export default __webpack_public_path__ + "static/media/icon_file_add_light.f35e2fc0.svg";
export { ForwardRef as ReactComponent };